import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { IcoCheckSmall16 } from '@onefootprint/icons';
import { Shimmer } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
type EditButtonProps = {
  icon: Icon;
  isDisabled?: boolean;
  isLoading?: boolean;
  isEmpty: boolean;
  isVerified: boolean;
  label: string;
  onClick: () => void;
  texts: {
    add: string;
    edit: string;
    verified: string;
  };
};
export const EditButton = t0 => {
  const $ = _c(23);
  const {
    label,
    icon: IconComponent,
    onClick,
    isDisabled,
    isLoading,
    isVerified,
    isEmpty,
    texts
  } = t0;
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Shimmer height="48px" width="auto" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = isDisabled ? "quaternary" : "primary";
  let t2;
  if ($[1] !== IconComponent || $[2] !== t1) {
    t2 = <div className="flex items-center justify-center h-6 w-6"><IconComponent color={t1} /></div>;
    $[1] = IconComponent;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== label) {
    t3 = <div className="flex flex-1 overflow-hidden" data-dd-privacy="mask"><span className="text-label-2 text-primary text-ellipsis overflow-hidden whitespace-nowrap">{label}</span></div>;
    $[4] = label;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isVerified || $[7] !== texts.verified) {
    t4 = isVerified && <><div className="flex gap-0.5 items-center"><IcoCheckSmall16 color="quaternary" /><span className="text-label-2 text-quaternary">{texts.verified}</span></div><p className="text-label-2 text-quaternary">·</p></>;
    $[6] = isVerified;
    $[7] = texts.verified;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = isDisabled ? "text-quaternary" : "text-accent";
  let t6;
  if ($[9] !== t5) {
    t6 = cx("text-label-2", t5);
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = isEmpty ? texts.add : texts.edit;
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <span className={t6}>{t7}</span>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t4 || $[15] !== t8) {
    t9 = <div className="flex flex-row items-center gap-2 justify-end">{t4}{t8}</div>;
    $[14] = t4;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== isDisabled || $[18] !== onClick || $[19] !== t2 || $[20] !== t3 || $[21] !== t9) {
    t10 = <button type="button" onClick={onClick} disabled={isDisabled} className="flex items-center border-none cursor-pointer select-none min-h-12 gap-2 py-3 px-4 rounded bg-secondary">{t2}{t3}{t9}</button>;
    $[17] = isDisabled;
    $[18] = onClick;
    $[19] = t2;
    $[20] = t3;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};